export const environment = {
  clientId: 'karima-spa'
};
